<ion-fab vertical="bottom" horizontal="end" slot="fixed" *ngIf="cs.myMemberShip?.role">
  <ion-fab-button (click)="clickDonation(null)">
    <ion-icon name="add"></ion-icon>
  </ion-fab-button>
</ion-fab>

<!-- Donation List Cards -->
<div class="scrollable tab-bar" *ngIf="cs.myMemberShip && ac.donationList?.length==0">
  <ion-row>
    <ion-col size="12" sizeMd="4" *ngFor="let donation of ac.donationList">
      <app-donation-card (clickDetails)="clickDonation($event)" [donation]="donation"
        [details]="false"></app-donation-card>
    </ion-col>
  </ion-row>
</div>

<ion-card color="light" style="text-align: center; margin-top: 30px;"
  *ngIf="cs.myMemberShip && ac.donationList?.length==0">
  <ion-card-content>
    <ion-icon name="information-circle-outline" style="font-size: 40px;"></ion-icon>
    <h2>No Donations Available</h2>
    <p>There are no donation posts available right now.</p>
  </ion-card-content>
</ion-card>